import React from 'react'
import {Input, Modal, Row, Col, Form, FormGroup, Label} from "reactstrap";
import Select from "react-select"
import DropImage from "../../components/DropImage"

const render_rows = (tog_standard, modal_standard, product, onChangeInput, updateCurrentProduct, brands, categories, handleAcceptedFiles) => {
    if(!product) return "";

    const { name, code, sku, price, color, size, brand_id, category_id, description, prod_img, image_url } = product;

    const brand = brands.find(x => x.value === brand_id);
    const category = categories.find(x => x.value === category_id);
    return (
        <Modal
            size="xl"
            isOpen={modal_standard}
            toggle={() => tog_standard('update')}
        >
            <div className="modal-header">
                <h5 className="modal-title mt-0" id="myModalLabel">
                    Actualizar producto
                </h5>
                <button type="button"
                        onClick={() => tog_standard('update')}
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                >
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body">
                <Form>
                    <Row>
                        <Col sm="9">
                            <Row>
                                <Col sm="4">
                                    <FormGroup>
                                        <Label htmlFor="bundle_qty">Nombre</Label>
                                        <Input type="text" className="form-control" defaultValue={ name } onChange={ e => {onChangeInput(e.target.value, 'name')} } />
                                    </FormGroup>
                                </Col>
                                <Col sm="4">
                                    <FormGroup>
                                        <Label htmlFor="bundle_qty">Codigo</Label>
                                        <Input type="text" className="form-control" defaultValue={ code } onChange={ e => {onChangeInput(e.target.value, 'code')} } />
                                    </FormGroup>
                                </Col>
                                <Col sm="4">
                                    <FormGroup>
                                        <Label htmlFor="bundle_qty">SKU</Label>
                                        <Input type="text" className="form-control" defaultValue={ sku } onChange={ e => {onChangeInput(e.target.value, 'sku')} } />
                                    </FormGroup>
                                </Col>
                                <Col sm="4">
                                    <FormGroup>
                                        <Label htmlFor="bundle_qty">Precio</Label>
                                        <Input type="number" className="form-control" defaultValue={ price } onChange={ e => {onChangeInput(Number(e.target.value), 'price')} } />
                                    </FormGroup>
                                </Col>
                                <Col sm="4">
                                    <FormGroup>
                                        <Label htmlFor="bundle_qty">Color</Label>
                                        <Input type="text" className="form-control" defaultValue={ color } onChange={ e => {onChangeInput(e.target.value, 'color')} } />
                                    </FormGroup>
                                </Col>
                                <Col sm="4">
                                    <FormGroup>
                                        <Label htmlFor="bundle_qty">Talle</Label>
                                        <Input type="text" className="form-control" defaultValue={ size } onChange={ e => {onChangeInput(e.target.value, 'size')} } />
                                    </FormGroup>
                                </Col>
                                <Col sm="4">
                                    <FormGroup>
                                        <Label htmlFor="weight">Marca</Label>
                                        <Select
                                          classNamePrefix="select1-selection"
                                          onChange={ brand => {onChangeInput( brand, 'brand')} }
                                          options={ brands }
                                          defaultValue={brand}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm="4">
                                    <FormGroup>
                                        <Label htmlFor="weight">Categoria</Label>
                                        <Select
                                          classNamePrefix="select1-selection"
                                          onChange={ category => {onChangeInput( category, 'category')} }
                                          options={ categories }
                                          defaultValue={category}
                                        />
                                    </FormGroup>
                                </Col>
                                <Col sm="12">
                                    <FormGroup>
                                        <Label htmlFor="bundle_qty">Descripción</Label>
                                        <textarea className="form-control" rows="2" style={{marginBottom: '10px'}} defaultValue={ description } onChange={ e => {onChangeInput(e.target.value, 'description')} } />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </Col>
                        <Col sm="3">
                            <i
                              onClick={ () => {onChangeInput( null, 'delete_img')} }
                              className={`mdi mdi-delete font-size-24 mr-2`}
                              style={{ color: '#f46a6a', position: 'absolute', right: '5%', top: '244px', display: image_url || (prod_img && prod_img.length > 0) ? 'block' : 'none' }}
                            />
                            <DropImage
                              on_drop_files={ (value) => handleAcceptedFiles(value) }
                              drop_file_type={'Imágen del producto'}
                              images={ prod_img || [] }
                            />
                            <div style={{display: image_url ? 'block' : 'none'}} className="dropzone-previews mt-3">
                                <img src={image_url} alt='product_img_1' className="post-slider-item img-fluid" />
                            </div>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div className="modal-footer">
                <button
                    type="button"
                    onClick={() => tog_standard('update')}
                    className="btn btn-secondary waves-effect"
                    data-dismiss="modal"
                >
                    Cancelar
                </button>
                <button
                    type="button"
                    onClick={updateCurrentProduct}
                    className="btn btn-primary waves-effect waves-light"
                    data-dismiss="modal"
                >
                    Actualizar
                </button>
            </div>
        </Modal>
    );
}

const ModalUpdateProduct = ({tog_standard, modal_standard, product, onChangeInput, updateCurrentProduct, brands, categories, handleAcceptedFiles}) => (
    render_rows(tog_standard, modal_standard, product, onChangeInput, updateCurrentProduct, brands, categories, handleAcceptedFiles)
)

export default ModalUpdateProduct
